module.exports = __webpack_public_path__ + "media/featured/VanityFair-cc376622.png";